import DetailsIcon from "@mui/icons-material/Info";
export default DetailsIcon;
